import React from 'react';
import Card from 'olive-react-myoneui/lib/Card';
import { achievementIcon, coursesBadge, programsBadge, certificateBadge } from '../../../constants/icons';
import AchievementsCounter from '../card/AchievementsCounter';
import { useSelector } from 'react-redux';
import { checkDisabledSp } from '../../../../helpers/permission_helper';

const LearnerAchievements = () => {
    const adminData = useSelector((state) => state.admin);
    const configData      = useSelector((state) => state.config);
    
    let achievementsData = [
        {
            title: 'Certificates achieved',
            certificateCounts: configData.certificatecount,
            badge: certificateBadge,
        },
        {
            title: 'Courses completed',
            certificateCounts: configData.coursecount,
            badge: coursesBadge,
        },
        {
            title: 'Programs completed',
            certificateCounts: configData.programcount,
            badge: programsBadge,
        },
    ];

    const isEportfolioEnabled = adminData.products.some(
        (value) => value.sp_slug === "eportfolio"
    );

    if(checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled)) {
        achievementsData = [
            {
                title: 'Certificates achieved',
                certificateCounts: configData.certificatecount,
                badge: certificateBadge,
            },
            {
                title: 'Programs completed',
                certificateCounts: configData.programcount,
                badge: programsBadge,
            },
        ];
    }

    if(!isEportfolioEnabled) {
        achievementsData = [
            {
                title: 'Certificates achieved',
                certificateCounts: configData.certificatecount,
                badge: certificateBadge,
            },
            {
                title: 'Courses completed',
                certificateCounts: configData.coursecount,
                badge: coursesBadge,
            }
        ];
    }

    if(checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) && !isEportfolioEnabled) {
        achievementsData = [{
            title: 'Certificates achieved',
            certificateCounts: configData.certificatecount,
            badge: certificateBadge,
        }]
    }

    const totalAchievements = 
        (configData.certificatecount || 0) +
        (configData.coursecount || 0) +
        (configData.programcount || 0);

    return (
        <Card className="myk__stu-achievements-wrapper pb-2 mb-4">
            <Card.Header className="mb-3">
                <h2>
                    {achievementIcon} Achievements <span className="myk__stu-learner-counter">{totalAchievements}</span>
                </h2>
            </Card.Header>
            <Card.Body>
                <ul className="myk__stu-achievements p-0 m-0 list-style-none">
                    {achievementsData.map((achievement, index) => (
                        <li key={index}>
                            <AchievementsCounter
                                title={achievement.title}
                                certificateCounts={achievement.certificateCounts}
                                badge={achievement.badge}
                            />
                        </li>
                    ))}
                </ul>
            </Card.Body>
        </Card>
    );
};

export default LearnerAchievements;
